import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/43_card_back_hydrangeas/43_card_back_hydrangeas"
 * Contains 1 texture(s)
 */
export class CardsBacks43CardBackHydrangeasAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/43_card_back_hydrangeas/43_card_back_hydrangeas';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '43_hydrangeas.png'
    ] as const;
}
